import { render } from "./CardRegistrationResultPage.vue?vue&type=template&id=6ebfa4f0&lang=html"
import script from "./CardRegistrationResultPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CardRegistrationResultPage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__